var map = {
  "./pt.po": [
    "4836",
    "589"
  ],
  "./es.po": [
    "4460",
    "109"
  ],
  "./en.po": [
    "2247",
    "620"
  ],
  "./da.po": [
    "267",
    "368"
  ],
  "./fr.po": [
    "3236",
    "533"
  ],
  "./it.po": [
    "7221",
    "758"
  ],
  "./de.po": [
    "4623",
    "324"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__(id);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 4501;
module.exports = __rspack_async_context;
